import React from "react";

const networkPoints = [
    {
        title: "Pan-India Presence",
        desc: "Our strong distribution network ensures product availability across major agricultural regions of India."
    },
    {
        title: "Timely & Reliable Supply",
        desc: "Efficient logistics and planning ensure farmers receive products exactly when they are needed."
    },
    {
        title: "Dealer & Distributor Support",
        desc: "We work closely with distributors and dealers to maintain consistent stock and service quality."
    },
    {
        title: "On-Ground Reach",
        desc: "From small villages to large farming belts, our network connects farmers directly to our solutions."
    }
];

const DistributionNetwork = () => {
    return (
        <section className="distribution-section">
            <div className="container">

                {/* HEADING */}
                <div className="text-center mb-5">
                    <h6 className="section-subtitle">DISTRIBUTION NETWORK</h6>
                    <h2 className="section-title">
                        Strong <span>Pan-India Reach</span>
                    </h2>
                    <p className="section-desc">
                        A dependable distribution system that ensures timely availability,
                        consistent supply, and strong on-ground support for farmers across India.
                    </p>
                </div>

                {/* CONTENT */}
                <div className="row align-items-center">

                    {/* LEFT IMAGE */}
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <div className="distribution-image">
                            <img
                                src="/images/img/12.jpg"
                                alt="Pan India Distribution Network"
                                className="img-fluid"
                            />
                        </div>
                    </div>

                    {/* RIGHT CARDS */}
                    <div className="col-lg-6">
                        <div className="row">
                            {networkPoints.map((item, index) => (
                                <div className="col-md-6 mb-4" key={index}>
                                    <div className="distribution-card">
                                        <h5>{item.title}</h5>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <a href="/contact" className="distribution-btn">
                            Partner With Us
                        </a>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default DistributionNetwork;
